import { ColorAA } from "./constants";

interface IconButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  variant?: "primary" | "secondary";
}

const IconButton = ({
  className,
  disabled,
  onClick,
  variant = "secondary",
}: IconButtonProps) => {
  const color = variant === "secondary" ? ColorAA.grey : ColorAA.blue;

  return (
    <button
      disabled={disabled}
      style={{ background: "none", border: "none", color }}
      onClick={onClick}
      className={className}
    />
  );
};

export default IconButton;
